import React, { useEffect, useState } from "react";
import "./LoginPage.css"; // Include your custom styles
import { Link, Navigate, useNavigate } from "react-router-dom";
import Notification from "../../components/Common/Notification";
import ActivityLoader from "../../components/Common/ActivityLoader";
import ajaxUser from "../../util/remote/ajaxUser";
import AlertVerifyEmail from "../../components/Welcome/AlertVerifyEmail";

const SignUpPage = () => {

    const [firstName, setFirstName] = useState('');
    const [surname, setSurname] = useState('');
    const [username, setUsername] = useState('');
    const [phoneNumber, setPhoneNumber] = useState('');
    const [password, setPassword] = useState('');
    const [rpassword, setRpassword] = useState('');
    const [notify, setNotify] = useState(false);
    const [loading, setLoading] = useState(false);
    const [showAlert, setShowAlert] = useState(false);
    const [codeRequested, setCodeRequested] = useState(false);
  
    const navigate = useNavigate();
  
    useEffect(()=>{
        if(!loading && notify){
            setTimeout(() => {
                setNotify(false);
            }, 5000);
        }
    }, [notify])

    
  
    const handleSignIn = () => {
        navigate('/login');
    }

    const handleSubmit = async (event)=>{
        event.preventDefault();
        if(password !== rpassword){
            setNotify(<Notification message="Sorry password do not match!" type='danger'/>);
            return;
        }

        if(loading){
            return;
        }

        if(phoneNumber.length < 12){
            setNotify(<Notification message="Invalid phone number!" type='danger'/>);
            return;
        }

        /**
         * Don't send email verification code if it has already been requested
         */
        if(codeRequested){
            setShowAlert(true);
            return;
        }

        //send email verification
        setLoading(true);
        const server_response = await ajaxUser.sendEmailVerification(username);
        setLoading(false);
        if(server_response.status === "OK"){
            setCodeRequested(true);
            setShowAlert(true);
            setNotify(<Notification message={server_response.message} type='success' closable={false}/>);
        }else{
            setNotify(<Notification message={server_response.message} type='danger' closable={false}/>);
        }

    }
  
   const handleSignup = async(verificationCode) =>{
      
        setLoading(true);
        const server_response = await ajaxUser.signup({
          "first_name":firstName,
          "surname":surname,
          "email":username,
          "phone_number":phoneNumber,
          "password":password,
          "email_verification_code":verificationCode
        });
        setLoading(false);
        setNotify(<div className='mb-3'><ActivityLoader /></div> )
        if(server_response.status === "OK"){
            setNotify(<Notification message={server_response.message} type='success'/>);
            setTimeout(() => {
              navigate('/login')
              window.location.reload();
            }, 3000);
          
        }else{
            setNotify(<Notification message={server_response.message} type='danger'/>);
        }
   }
  
   const isLoggedIn = localStorage.getItem('eschool@user');
  
   if (isLoggedIn) {
       return <Navigate to="/dashboard" />;
   }


  return (
    <>
    <div className="content">
      <div className="container">
        <div className="row">
          {/* Left Image Section */}
          <div className="col-md-6">
            {/* Logo Section */}
            <div className="text-left mb-4">
                  <img
                    src="assets/images/logo.svg" // Replace with your logo's path
                    alt="yexp logo"
                    className="logo"
                    style={{ maxWidth: "60px", height: "auto", position: 'absolute'}} // Adjust size as needed
                  />
                </div>
            <img
              src="assets/images/undraw_remotely_2j6y.svg"
              alt="Illustration"
              className="img-fluid"
            />
          </div>

          {/* Right Login Section */}
          <div className="col-md-6 contents">
            <div className="row justify-content-center">
              <div className="col-md-8">
                
                <div className="mb-4">
                    <h3>Sign Up</h3>
                    <p className="mb-4">
                        Complete the details below to get started with eSchool.
                    </p>
                </div>
                <form action="#" method="post" onSubmit={handleSubmit}>
                    {notify}
                    <div className={`form-group first ${surname.length > 0 ? 'field--not-empty': ''}`}>
                        <label htmlFor="surname">Surname</label>
                        <input
                            type="text"
                            className="form-control"
                            value={surname}
                            onChange={(e)=>setSurname(e.target.value)}
                            id="surname"
                            required
                        />
                    </div>

                    <div className={`form-group first ${firstName.length > 0 ? 'field--not-empty': ''}`}>
                        <label htmlFor="firstName">First Name</label>
                        <input
                            type="text"
                            className="form-control"
                            value={firstName}
                            onChange={(e)=>setFirstName(e.target.value)}
                            id="firstName"
                            required
                        />
                    </div>

                    <div className={`form-group first ${username.length > 0 ? 'field--not-empty': ''}`}>
                        <label htmlFor="email">Email</label>
                        <input
                            type="email"
                            className="form-control"
                            onChange={(e)=>setUsername(e.target.value)}
                            value={username}
                            id="email"
                            required
                        />
                    </div>

                    <div className={`form-group first ${phoneNumber.length > 0 ? 'field--not-empty': ''}`}>
                        <label htmlFor="phone">Phone Number</label>
                        <input
                            type="text"
                            className="form-control"
                            value={phoneNumber}
                            onChange={(e) => {
                                const value = e.target.value.replace(/\D/g, ''); // Remove non-numeric characters (except +)
                                if (value.startsWith('0')) return; // Prevent input starting with 0
                                const formatted = value
                                    .replace(/^(\d{1,3})(\d{0,3})/, '+$1 $2') // Country code (e.g., +256)
                                    .replace(/(\d{3})(\d{0,3})$/, '$1 $2')    // First group of digits
                                    .replace(/(\d{3}) (\d{3})(\d{0,3})$/, '$1 $2 $3'); // Add spaces between groups
                                setPhoneNumber(formatted.trim());
                            }}
                            maxLength={15}
                            required
                            id="phone"
                        />
                    </div>

                    <div className={`form-group first ${password.length > 0 ? 'field--not-empty': ''}`}>
                        <label htmlFor="password">Password</label>
                        <input
                            type="password"
                            className="form-control"
                            onChange={(e)=>setPassword(e.target.value)}
                            id="password"
                            required
                        />
                    </div>

                    <div className={`form-group first ${rpassword.length > 0 ? 'field--not-empty': ''}`}>
                        <label htmlFor="re-password">Re-type Password</label>
                        <input
                            type="password"
                            className="form-control"
                            value={rpassword}
                            onChange={(e)=>setRpassword(e.target.value)}
                            id="re-password"
                            required
                        />
                    </div>

                    <div className="d-flex mb-3 align-items-center"></div>
                    <input
                        type="submit"
                        value={showAlert ? "Email Verification...." : loading ? "Please wait" : "Create Account"}
                        className="btn btn-block btn-success"
                    />
                    <span className="d-block text-left my-4 text-muted">
                        &mdash; or already signed up? &mdash;
                    </span>
                    <button className="btn btn-block btn-light" onClick={handleSignIn}>Sign in</button>
            </form>
            </div>
            </div>
            </div>
        </div>
                
      </div>
    </div>
    <AlertVerifyEmail
        show={showAlert}
        email={username}
        onClose={()=>setShowAlert(false)}
        onConfirm={(code)=>handleSignup(code)}
    />
    </>
  );
};

export default SignUpPage;
